import { gql } from '@apollo/client'

export const POST_PROPERTY_DISCLOSURE_FORM = gql`
  mutation PostPropertyDisclosureForm($input: PropertyDisclosureInput!) {
    postPropertyDisclosureForm(input: $input) {
      success
    }
  }
`

export const GET_PROPERTY_DISCLOSURE_SUBMISSION_STATUS = gql`
  query GetPropertyDisclosureSubmissionStatus($transaction_id: Int!) {
    getPropertyDisclosureSubmissionStatus(transaction_id: $transaction_id) {
      submitted
    }
  }
`
